import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useAuthStore } from '@/stores/auth'
import DashboardView from '@/views/DashboardView.vue'
import PostsView from '@/views/PostsView.vue'
import ManualAddView from '@/views/ManualAddView.vue'
import LoginView from '@/views/LoginView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'dashboard', component: DashboardView, meta: { requiresAuth: true } },
    { path: '/posts', name: 'posts', component: PostsView, meta: { requiresAuth: true } },
    { path: '/sources', name: 'sources', component: () => import('@/views/SourcesView.vue'), meta: { requiresAuth: true } },
    { path: '/reports', name: 'reports', component: () => import('@/views/ReportsView.vue'), meta: { requiresAuth: true } },
    {
      path: '/manual-add',
      name: 'manual-add',
      component: ManualAddView,
      meta: { requiresAuth: true, requiresCreateManualPost: true },
    },
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
  ],
})

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath },
      replace: true,
    })
  }

  if (to.meta.requiresCreateManualPost && !authStore.canCreateManualPost) {
    ElMessage.error('Недостаточно прав')
    return next({ path: '/', replace: true })
  }

  if (to.meta.public && authStore.isAuthenticated && to.path === '/login') {
    const redirect = (to.query.redirect as string) || '/'
    return next({ path: redirect, replace: true })
  }

  next()
})

export default router
